<script>
  import { link as svelteLink } from "svelte-routing";

  export let link;
  export let text;
  export let description = null;
  export let draggable = false;
  export let unread = false;
  export let isActive = false;
  export let isDragging = false;
</script>

<a href={link} use:svelteLink on:click>
  <div
    class="item"
    class:isActive
    ondragover="return false"
    on:drop
    on:dragenter
    on:dragleave
    draggable={draggable ? 'true' : null}
    on:dragstart
    on:dragend
  >
    <div class:isDragging>
      <slot name="icon" />
    </div>
    <div class="title" class:isDragging class:unread>
      <h2 class="title-header nopointer">{text}</h2>
      <slot name="tag" />
      {#if description}
        <p class="nopointer">{description}</p>
      {/if}
    </div>
    <div class="meta" class:isDragging>
      <div class="actions">
        <slot name="actions" />
      </div>
      <div class="stats">
        <slot name="stats" />
      </div>
    </div>
  </div>
</a>

<style>
  .item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 0;
    margin: 8px 0;
    cursor: pointer;
    transition: background-color 0.3s ease-in-out;
  }

  .item .isDragging {
    pointer-events: none;
  }

  .item.isActive {
    outline: 4px solid #3273dc;
  }

  .item:hover {
    background-color: #f9f9f9;
  }

  .nopointer {
    pointer-events: none;
  }

  .title {
    flex: 1;
  }

  .title.unread {
    font-weight: 700;
  }

  .title-header {
    display: inline;
  }

  .actions {
    margin-right: 1rem;
    display: flex;
    align-items: baseline;
  }

  .meta {
    display: flex;
    align-items: center;
  }

  h2 {
    font-weight: inherit;
    font-size: 16px;
    margin: 0;
  }

  .item p {
    color: #999;
    font-size: 12px;
    margin: 0;
    margin-top: 6px;
  }

  .stats {
    text-align: right;
    color: black;
    font-size: 12px;
  }
</style>
